import { useState, useEffect } from 'react';
import fetchExpresso from 'utility/fetchExpresso';
import moment from 'moment-timezone';
import { useNotification } from 'context/notification';

export function useErrorLog() {
    const [errorLog, setErrorLog] = useState(null);

    const { notify } = useNotification();

    useEffect(() => {
        getErrorLog()
            .then((log) => setErrorLog(log))
            .catch((err) => {
                setErrorLog([]);
                notify.error(err);
            });
        // eslint-disable-next-line
    }, []);

    return errorLog;
}

async function getErrorLog() {
    const start = moment().tz('America/Toronto').subtract(5, 'days').format('YYYY-MM-DDT00:00:00');
    const end = moment().tz('America/Toronto').format('YYYY-MM-DDT23:59:59');

    const response = await fetchExpresso(
        `/admin/logs/error_log?start=${start}&end=${end}&tz=${moment.tz.guess()}`,
    );

    if (response.status === 200) {
        const { errorLog } = await response.json();

        const result = [];

        for (const log of errorLog) {
            result.push(new ErrorLog(log));
        }

        return result;
    } else if (response.status === 400) {
        throw new Error(`[400] Bad request`);
    } else if (response.status === 500) {
        throw new Error(`[500] There was a problem on our end`);
    } else {
        throw new Error(`[${response.status}] Something went wrong`);
    }
}

class ErrorLog {
    constructor(params) {
        this.id = params.error_id;
        this.host = params.host_name;
        this.event = params.event_title;
        this.deviceName = params.device_name || '';
        this.deviceId = params.device_id || '';
        this.deviceBrand = params.device_brand || '';
        this.deviceModel = params.device_model || '';
        this.deviceOsName = params.device_os_name || '';
        this.deviceOsVersion = params.device_os_version || '';
        this.deviceCarrier = params.device_carrier || '';
        this.deviceCellularGeneration = params.device_cellular_generation || '';
        this.deviceNetworkType = params.device_network_type || '';
        this.appVersion = params.app_version;
        this.date = params.created_at;
        this.code = params.error_code || '';
        this.message = params.error_message || '';
        this.data = params.error_data || '';
    }
}
